// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"249b64ab","438":"30f8960c","780":"e2eb4611","868":"05d873e7"}[chunkId] + ".chunk.css";
};